export const getThisMonthDateRange = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = `0${today.getMonth() + 1}`.slice(-2);
    const day = `0${today.getDate()}`.slice(-2);

    return {
        from: `${year}-${month}-01`,
        to: `${year}-${month}-${day}`
    };
};

export const thisMonthDateRange = getThisMonthDateRange();

export const rrFormatPhoneNumber = (phoneNumber) => (phoneNumber && phoneNumber.substring(0, 2) !== '+1' ? `+1${phoneNumber}` : phoneNumber);
export const rrUnFormatPhoneNumber = (phoneNumber) => (phoneNumber && phoneNumber.substring(0, 2) === '+1' ? phoneNumber.slice(2) : phoneNumber);
